import { render, staticRenderFns } from "./_Root.vue?vue&type=template&id=213ed12e&lang=pug&"
import script from "./_Root.vue?vue&type=script&lang=js&"
export * from "./_Root.vue?vue&type=script&lang=js&"
import style0 from "./_Root.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213ed12e')) {
      api.createRecord('213ed12e', component.options)
    } else {
      api.reload('213ed12e', component.options)
    }
    module.hot.accept("./_Root.vue?vue&type=template&id=213ed12e&lang=pug&", function () {
      api.rerender('213ed12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayouts/_Root.vue"
export default component.exports